import { namespace } from 'vuex-class'

export enum ModalType {
    ConfirmAction,
    Success,
    Error,
    ShareLink
}

export interface IModalParams {
    modal: ModalType
    payload?: any
    callback?: () => void
}

export interface ModalState {
    activeModal: IModalParams
    isLoading: boolean
}

export const ModalStore = namespace('modal')

export default {
    namespaced: true,
    state: {
        activeModal: {
            modal: null,
            callback: null,
            payload: null
        },
        isLoading: true
    } as ModalState,
    mutations: {
        SET_LOADING_STATE: (state: ModalState, payload: boolean) => (state.isLoading = payload),
        SET_ACTIVE_MODAL: (state: ModalState, { modal, payload, callback }: IModalParams) => {
            state.activeModal.modal = modal
            state.activeModal.callback = modal === null ? null : callback
            state.activeModal.payload = modal === null ? null : payload
            // if it's success message, close it back after 2 seconds
            if (modal === ModalType.Success) setTimeout(() => (state.activeModal.modal = null), 2500)
        }
    }
}
